// PapaJohnsDropdownMenu.tsx
import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import { FaBars } from 'react-icons/fa';

const styles: { [key: string]: React.CSSProperties } = {
  menuContainer: {
    display: 'inline-block',
    width: '50px', // Set this to the width of your menu icon
    position: 'relative',
    '@media (max-width: 768px)': {
      width: '4vw', // adjust padding for mobile as needed
    },
  },
  menuIcon: {
    cursor: 'pointer',
    position: 'relative', // The menu will be positioned relative to this
  },
  menu: {
    cursor: 'pointer',
    position: 'absolute',
    top: '100%', // Position the menu below the icon
    right: 0,
    backgroundColor: 'white',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    padding: '15px',
    zIndex: 1000,
    minWidth: '200px',
    marginTop: '10px', // Give some space between the icon and the menu
    overflow: 'hidden',
    opacity: 0.95,
    transition: 'opacity 250ms ease-in-out',
  },
  menuItem: {
    padding: '12px 15px',
    borderBottom: '1px solid #eaeaea',
    ':last-child': {
      border: 'none',
    },
    ':hover': {
      backgroundColor: '#f8f9fa', // Light grey background on hover
    },
  },
  menuLink: {
    textDecoration: 'none',
    color: '#333',
    fontSize: '16px',
    fontWeight: 'bold',
    display: 'block',
    transition: 'color 250ms ease-in-out',
    ':hover': {
      color: '#008e6a', // Highlight text on hover
    },
  },
};

interface PapaJohnsDropdownMenuProps {
    isMenuOpen: boolean;
    toggleMenu: () => void;
  }
  
  class PapaJohnsDropdownMenu extends React.Component<PapaJohnsDropdownMenuProps, {}> {
    menuRef: HTMLDivElement | null = null;  
    iconRef: HTMLDivElement | null = null;


    constructor(props: PapaJohnsDropdownMenuProps) {
      super(props);
      this.handleClickOutside = this.handleClickOutside.bind(this);
      this.closeMenu = this.closeMenu.bind(this);
      this.toggleMenu = this.toggleMenu.bind(this);

    }

    componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  
    componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  
    
    closeMenu() {
      // If the menu is open, close it
      if (this.props.isMenuOpen) {
        this.props.toggleMenu();
      }
    }
    
    handleClickOutside = (event: MouseEvent): void => {
      if (this.menuRef && !this.menuRef.contains(event.target as Node) &&
          this.iconRef && !this.iconRef.contains(event.target as Node) &&
          this.props.isMenuOpen) {
        this.props.toggleMenu(); // Close the menu
      }
    };

    toggleMenu = (event) => {
      event.stopPropagation();
      this.props.toggleMenu();
    };
    
    
    
    render() {
      const { isMenuOpen } = this.props;
  
      return (
        <div style={styles.menuContainer}>
          <div ref={ref => this.iconRef = ref} onClick={this.toggleMenu}>
            <FaBars style={styles.menuIcon} size={24} />
          </div>          
        {isMenuOpen && (
        <div ref={(ref) => (this.menuRef = ref)} style={styles.menu} onClick={(event) => event.stopPropagation()}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={styles.menuItem} key="shirtOfMonth">
                  <a href="/papajohns/shirt-of-the-month" target='_blank' style={styles.menuLink} key="shirtOfMonthA">Shirt of the Month Club</a>
                </li>
                <li style={styles.menuItem} key="viewAllDesigns">
                  <a href="/PapaJohns/view-designs" style={styles.menuLink} key="viewAllDesignsA">View all Designs</a>
                </li>
                <li style={styles.menuItem} key="getHelp">
                  <a href="mailto:sales@grafcow.com" style={styles.menuLink} key="getHelpA">Get Help</a>
                </li>
                {/* Additional menu items here */}
              </ul>
            </div>
          )}
        </div>
      );
    }
  }
  
  export default Radium(PapaJohnsDropdownMenu);